export default function checkIfCanUpdateQuestionsRoutes({ next, store }) {
  let scopes = store.getters.userScopes;
  return scopes.includes('manage_questions_update') ? next() : next({ name: 'dashboard' });
}
